import { generateUsername } from '@/domain/services/auth/authService';

/**
 * GenerateUsernameUseCase
 *
 * Generates a unique username from a display name.
 * Delegates to authService which handles uniqueness checking via Firestore.
 */
export class GenerateUsernameUseCase {
    async execute(name: string): Promise<string> {
        return generateUsername(name);
    }
}

export const generateUsernameUseCase = new GenerateUsernameUseCase();
